import { configureStore } from "@reduxjs/toolkit";
import modelsReducer from "../features/models"
import userReducer from "../features/user";
import taskReducer from "../features/tasks"
export const store = configureStore({
  reducer: { user: userReducer,models:modelsReducer,task:taskReducer },
});
